// import React from 'react';
import { useState } from 'react';
import Navbar from '../../components/navbar/Navbar';
import Sidebar from '../../components/navbar/Sidebar';
import Footer from '../../components/footer/Footer'; 
import LegacyUniformPolicyBody from '../../components/internal/LegacyHighSchool/LegacyUniformPolicy/LegacyUniformPolicyBody';

function LegacyUniformPolicy() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <>
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <LegacyUniformPolicyBody />
      <Footer />
    </>
  );
}

export default LegacyUniformPolicy;